// extracted by mini-css-extract-plugin
module.exports = {"mid":"Resume_mid__2vTpG","flex":"Resume_flex__1T1av","first":"Resume_first__2Zeae","btn":"Resume_btn__2lLRS","img":"Resume_img__vthKl","second":"Resume_second__FEC9E"};